import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { EEstimationTargets } from '../../types';
import { EActionTypes as EFiltersActions, ECurrentErrorField } from '../../actions/filters/types';
import { EActionTypes as EFlatAreasSuggestActions } from '../../actions/getFlatAreasSuggest/types';
import { EActionTypes as EAddressGeoSuggestActions } from '../../actions/getAddressGeoSuggest/types';
export var initialFiltersState = {
  address: '',
  userSetArea: false,
  errorTooltip: {
    currentErrorField: ECurrentErrorField.none,
    errorText: ''
  },
  estimationTarget: EEstimationTargets.flat,
  area: undefined,
  roomsCount: undefined,
  landArea: undefined,
  houseArea: undefined,
  addressGeoSuggest: {
    suggestData: undefined,
    isFetching: false,
    error: undefined
  },
  flatAreasSuggest: {
    flatAreas: null
  }
};
/**
 * Этот редюсер экспортируется и должен быть встроен в редюсер целевого мкс
 * */

export var filtersReducer = function filtersReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialFiltersState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case EFiltersActions.SET_ADDRESS:
      return _objectSpread(_objectSpread({}, state), {}, {
        address: action.payload.address
      });

    case EFiltersActions.SET_ROOMS:
      return _objectSpread(_objectSpread({}, state), {}, {
        roomsCount: action.payload.roomsCount
      });

    case EFiltersActions.SET_JK_ROOMS:
      return _objectSpread(_objectSpread({}, state), {}, {
        jkRoomsCount: action.payload.jkRoomsCount
      });

    case EFiltersActions.SET_AREA:
      return _objectSpread(_objectSpread({}, state), {}, {
        area: action.payload.area
      });

    case EFiltersActions.SET_LAND_AREA:
      return _objectSpread(_objectSpread({}, state), {}, {
        landArea: action.payload.landArea
      });

    case EFiltersActions.SET_HOUSE_AREA:
      return _objectSpread(_objectSpread({}, state), {}, {
        houseArea: action.payload.houseArea
      });

    case EFiltersActions.SET_USER_AREA_FLAG:
      return _objectSpread(_objectSpread({}, state), {}, {
        userSetArea: action.payload.userSetArea
      });

    case EFiltersActions.SET_ERROR:
      return _objectSpread(_objectSpread({}, state), {}, {
        errorTooltip: {
          currentErrorField: action.payload.currentErrorField,
          errorText: action.payload.errorText
        }
      });

    case EFiltersActions.SET_ESTIMATION_TARGET:
      return _objectSpread(_objectSpread({}, state), {}, {
        estimationTarget: action.payload.estimationTarget
      });

    case EFiltersActions.SET_NEWBUILDING_ID:
      return _objectSpread(_objectSpread({}, state), {}, {
        newbuildingId: action.payload.newbuildingId
      });

    case EFiltersActions.SET_HOUSE_ID:
      return _objectSpread(_objectSpread({}, state), {}, {
        houseId: action.payload.houseId
      });

    case EFiltersActions.RESET_FILTERS:
      return _objectSpread(_objectSpread({}, initialFiltersState), {}, {
        estimationTarget: state.estimationTarget
      });

    case EAddressGeoSuggestActions.GET_ADDRESS_GEO_SUGGEST_REQUEST:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          addressGeoSuggest: _objectSpread(_objectSpread({}, state.addressGeoSuggest), {}, {
            isFetching: true,
            error: undefined
          })
        });
      }

    case EAddressGeoSuggestActions.GET_ADDRESS_GEO_SUGGEST_SUCCESS:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          addressGeoSuggest: _objectSpread(_objectSpread({}, state.addressGeoSuggest), {}, {
            isFetching: false,
            error: undefined,
            suggestData: action.payload
          })
        });
      }

    case EAddressGeoSuggestActions.GET_ADDRESS_GEO_SUGGEST_FAILURE:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          addressGeoSuggest: _objectSpread(_objectSpread({}, state.addressGeoSuggest), {}, {
            suggestData: undefined,
            isFetching: false,
            error: action.payload
          })
        });
      }

    case EFlatAreasSuggestActions.FLAT_AREA_SUCCESS_RESPONSE:
      return _objectSpread(_objectSpread({}, state), {}, {
        flatAreasSuggest: action.payload
      });

    default:
      return state;
  }
};